import { Injectable } from '@angular/core';
import { AppSettingService } from './app-setting.service';

@Injectable()
export class LoginInfoService {

  constructor(
    private appSettingService: AppSettingService) { }

  private publicKey: string = null;
  //设置公钥
  public setPublicKey(publicKey: string) {
    this.publicKey = publicKey;
  }

  //获取权限列表
  public getAllowPerm(): Array<PermConfig> {
    var permListString = this.getLocalstorage('ALLOW_PERMS');
    if (permListString == null || permListString == "")
      return [];
    var obj: Array<PermConfig> = JSON.parse(permListString);
    return obj;
  }

  private static allPermMap = null;
  //获取权限树
  public getAllPermMap() {
    if (LoginInfoService.allPermMap == null) {
      LoginInfoService.allPermMap = {};
      var permAllString = this.getLocalstorage('ALL_PERMS');
      if (permAllString == null || permAllString == "")
        return [];
      var permAll: Array<PermConfig> = JSON.parse(permAllString).filter(p => p.pagePath != null && p.pagePath != '');
      for (var i in permAll) {
        if (permAll[i].pagePath == null || permAll[i].pagePath == "") {
        } else {
          LoginInfoService.allPermMap[permAll[i].pagePath.toLowerCase()] = permAll[i];
        }
      }
    }

    return LoginInfoService.allPermMap;
  }

  public getKeyCodeByPageUrl(pageUrl: string) {
    if (this.appSettingService.getLocalDebug()) {
      return ""
    } else {
      let permMap = this.getAllPermMap();
      let pageCode = permMap[pageUrl.toLowerCase()];
      if (pageCode == null)
        pageCode = "";
      return pageCode.keyCode;
    }
  }

  public checkPerm(keyCode: string) {
    keyCode = keyCode.replace('.', ',').toLowerCase();
    let permList = this.getAllowPerm();
    return permList.filter(x => x.keyCode == keyCode).length > 0;
  }
  //获取公钥
  public getPublicKey(): string {
    return this.publicKey;
  }

  public setLoginInfo(loginInfo: LoginInfoModel) {
    var loginString = JSON.stringify(loginInfo);
    this.setCookie('TOKEN', loginString);
  }

  public getLoginInfo(): LoginInfoModel {
    var loginString = this.getCookie('TOKEN');
    if (loginString == null || loginString == "")
      return {
        "loginToken": null,
        "loginUser": null,
        "companyId": null,
        "departmentId": null,
        "userId": null,
        "realName": null,
        "CompanyType": null,
        "PasswordComplexity": null,
        "parentCompanyId": null
      } as LoginInfoModel;
    var obj = JSON.parse(loginString);
    var loginInfo: LoginInfoModel = {
      "parentCompanyId": obj.CompanyId,
      "loginToken": obj.Token,
      "loginUser": obj.UserName,
      "companyId": obj.CurrCompanyId,
      "departmentId": obj.DepartId,
      "userId": obj.UserId,
      "realName": obj.RealName,
      "CompanyType": obj.CompanyType,
      "PasswordComplexity": obj.PasswordComplexity
    }
    return loginInfo;
  }

  public abondonCookie() {
    this.setCookie('loginInfo', "");
  }

  //设置cookie
  public setCookie(name, value) {
    var now = new Date();
    now.setDate(now.getDate() + 1);
    document.cookie = name + "=" + value + ";expires=" + now.toUTCString() + ";path=/";
  }
  //读取cookie
  public getCookie(name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(name + "=")
      if (c_start != -1) {
        c_start = c_start + name.length + 1
        var c_end = document.cookie.indexOf(";", c_start)
        if (c_end == -1) c_end = document.cookie.length
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return ""
  }

  public setLoclstorage(name, value) {
    localStorage.setItem(name, value);
  }
  public getLocalstorage(name) {
    if (localStorage.length > 0) {
      return localStorage.getItem(name);
    }
    return "";
  }
}

export interface LoginInfoModel {
  loginToken: string;
  loginUser: number;
  companyId: number,
  parentCompanyId: number,
  departmentId: number,
  userId: number,
  realName: string,
  CompanyType: number,
  PasswordComplexity: any  //1-低级  2-中级  3-高级
}

export interface PermConfig {
  permid: number;
  text: string;
  keyCode: string;
  pagePath: string;
}
